<!--
 * @Author: daidai
 * @Date: 2022-02-28 16:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-20 17:57:11
 * @FilePath: \web-pc\src\pages\big-screen\view\indexs\left-center.vue
-->
<template>
    <ul class="user_Overview flex" v-if="pageflag">
        <li class="user_Overview-item" style="color: #07f7a8">
            <div class="user_Overview_nums">
                <dv-digital-flop :config="amClockInRateConfig" style="width:100%;height:100%;" />
            </div>
            <p>上午打卡率</p>
        </li>
        <li class="user_Overview-item" style="color: #07f7a8">
            <div class="user_Overview_nums">
                <dv-digital-flop :config="pmClockInRateConfig" style="width:100%;height:100%;" />
            </div>
            <p>下午打卡率</p>
        </li>
    </ul>
    <Reacquire v-else @onclick="getData" line-height="200px">
        重新获取
    </Reacquire>
</template>

<script>
import { currentGET } from '@/api/modules'
import { statCurDateEquClockInRate } from 'api/modules/largescreen'
let style = {
    fontSize: 24
}
export default {
    data() {
        return {
            options: {},
            userOverview: {
                alarmNum: 0,
                offlineNum: 0,
                onlineNum: 0,
                totalNum: 0,
            },
            pageflag: true,
            timer: null,
            onlineconfig: {
                number: [0],
                content: '{nt}',
                style: {
                    ...style,
                    // stroke: "#07f7a8",
                    fill: "#07f7a8",
                },
            },
            amClockInRateConfig: {
                number: [0],
                toFixed : 2,
                content: '{nt}%',
                style: {
                    ...style,
                    // stroke: "#00fdfa",
                    fill: "#07f7a8",
                    fontSize: 35,
                },
            },
            offlineconfig: {
                number: [0],
                content: '{nt}',
                style: {
                    ...style,
                    // stroke: "#e3b337",
                    fill: "#07f7a8",
                },
            },
            pmClockInRateConfig: {
                number: [0],
                toFixed : 2,
                content: '{nt}%',
                style: {
                    ...style,
                    // stroke: "#f5023d",
                    fill: "#07f7a8",
                    fontSize: 35,
                },
            }

        };
    },
    filters: {
        numsFilter(msg) {
            return msg || 0;
        },
    },
    created() {
        this.getData()
    },
    mounted() {
    },
    beforeDestroy() {
        this.clearData()

    },
    methods: {
        clearData() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        getData() {
            this.pageflag = true;
            // currentGET("big2").then((res) => {
            //     if (!this.timer) {
            //         console.log("设备总览", res);
            //     }
            //     if (res.success) {
            //         this.userOverview = res.data;
            //         this.onlineconfig = {
            //             ...this.onlineconfig,
            //             number: [res.data.onlineNum]
            //         }
            //         this.config = {
            //             ...this.config,
            //             number: [res.data.totalNum]
            //         }
            //         this.offlineconfig = {
            //             ...this.offlineconfig,
            //             number: [res.data.offlineNum]
            //         }
            //         this.laramnumconfig = {
            //             ...this.laramnumconfig,
            //             number: [res.data.alarmNum]
            //         }
            //         this.switper()
            //     } else {
            //         this.pageflag = false;
            //         this.$Message.warning(res.msg);
            //     }
            // });


            statCurDateEquClockInRate().then((res) => {
                if (!this.timer) {
                    console.log("设备打卡率", res);
                }
                if (res.code == 200) {
                    let dpShowAreaId = localStorage.getItem("dpShowAreaId");

                    this.userOverview = res.data;
                    let resData = res.data;

                    // 广元利州区设置默认值 20260521 baoxiaoyu add
                    //if(dpShowAreaId == '510802'){
                    //    resData.amClockInRate = "100";
                    //    let currentHour = new Date().getHours();
                        // 判断是否超过13点
                    //    if (currentHour >= 13) {
                    //        resData.pmClockInRate = "100";
                    //    }
                    //}

                    // this.onlineconfig = {
                    //     ...this.onlineconfig,
                    //     number: [res.data.onlineNum]
                    // }
                    this.amClockInRateConfig = {
                        ...this.amClockInRateConfig,
                        number: [parseFloat(resData.amClockInRate)]
                    }
                    // this.offlineconfig = {
                    //     ...this.offlineconfig,
                    //     number: [res.data.offlineNum]
                    // }
                    this.pmClockInRateConfig = {
                        ...this.pmClockInRateConfig,
                        number: [parseFloat(resData.pmClockInRate)]
                    }
                    this.switper()
                } else {
                    this.pageflag = false;
                    this.$Message.warning(res.msg);
                }
            });
        },
        //轮询
        switper() {
            if (this.timer) {
                return
            }
            let looper = (a) => {
                this.getData()
            };
            this.timer = setInterval(looper, this.$store.state.setting.echartsAutoTime);
        },
    },
};
</script>
<style lang='scss' scoped>
.user_Overview {
    li {
        flex: 1;

        p {
            text-align: center;
            height: 5px;
            font-size: 24px;
            margin-top: 0px;
        }

        .user_Overview_nums {
            width: 150px;
            height: 60px;
            text-align: center;
            line-height: 50px;
            font-size: 24px;
            margin-left: 70px;
            background-size: cover;
            background-position: center center;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
            }

            &.bgdonghua::before {
                animation: rotating 14s linear infinite;
            }
        }

        .allnum {

            // background-image: url("../../assets/img/left_top_lan.png");
            &::before {
                background-image: url("../../assets/img/left_top_lan.png");

            }
        }

        .online {
            &::before {
                background-image: url("../../assets/img/left_top_lv.png");

            }
        }

        .offline {
            &::before {
                background-image: url("../../assets/img/left_top_huang.png");

            }
        }

        .laramnum {
            &::before {
                background-image: url("../../assets/img/left_top_hong.png");

            }
        }
    }
}
</style>